export default {
    props: {
        element: {
            type: Object,
            required: true
        }
    }
}